// Live filter for the Photography Queue table. Operators were finding an item with
// Ctrl+F (2026-10-19). Every word typed must appear somewhere in the row, in any
// order and any case, so "fender red" and "red fender" find the same bass.

/** The text a queue row can be found by: what the operator sees, plus the trade reference. */
function searchText(item) {
  return [
    item.product_name,
    item.brand,
    item.product_type,
    item.source_reference,
    item.source,
  ].filter(Boolean).join(' ').toLowerCase()
}

/** The items whose row text contains every word of `query`. A blank query keeps them all. */
export function filterPhotographyQueue(items, query) {
  const words = (query || '').toLowerCase().split(/\s+/).filter(Boolean)
  if (words.length === 0) return items
  return items.filter(item => {
    const text = searchText(item)
    return words.every(word => text.includes(word))
  })
}
